import angular from "angular";
import DialogService from "./DialogService";
import angularBoostrapModal from "angular-ui-bootstrap/src/modal/modal";
import angularBootstrapBackdropTemplate from "angular-ui-bootstrap/template/modal/backdrop.html.js";
import angularBootstrapWindowTemplate from "angular-ui-bootstrap/template/modal/window.html.js";
import dcSelect from "modules/dc-ui/dc-select";
import dcuiCheckbox from "modules/dcui/dcui-checkbox/dcui-checkbox.component.js";

export default angular.module("dc-ui.dc-modal",["ui.bootstrap.modal","uib/template/modal/backdrop.html","uib/template/modal/window.html", dcSelect, dcuiCheckbox])
.factory("DialogService",DialogService)
.factory("dcModalService",DialogService)
.name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-modal/index.js